import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }

    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #dcebfa;
        overflow-x: hidden;
    }

    a:hover {
        color: #18216d;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: #18216d;
        font-size: 56px;
        line-height: 1.18;
        text-align: center;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: #18216d;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .video-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
    }

    .video-wrapper {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%; /* 16:9 aspect ratio */
        overflow: hidden;

        & iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: none;
        }
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

    /* 🎠 Estilos del carrusel */
    /* 🎠 Estilos del carrusel */
.carousel-container {
    background: linear-gradient(135deg, #0093d1, #2862ac);
    padding: 2rem;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.2);
    transition: background 0.5s ease-in-out;
    position: relative; /* necesario para posicionar flechas */
    max-width: 1200px;
    margin: 0 auto;
}


.carousel-wrapper {
    width: 100%;
    overflow: hidden;
    position: relative;
}

.carousel-track {
    display: flex;
    transition: transform 0.5s ease-in-out;
    width: 100%; 
}

.carousel-item {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
    background: rgba(255, 255, 255, 0.12);
    border-radius: 16px;
    padding: 2rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.25);
    color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.carousel-image {
    max-width: 150px;
    height: auto;
    border-radius: 10px;
    margin-bottom: 1rem;
    box-shadow: 0 0 10px rgba(0,0,0,0.15);
}

.carousel-nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: #c0006d;
    color: white;
    border: none;
    padding: 12px;
    cursor: pointer;
    font-size: 20px;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    transition: background 0.3s ease;
    z-index: 10;
}

.carousel-nav-button:hover {
    background-color: #f2774d;
}

.carousel-nav-button-left {
    left: 10px;
}

.carousel-nav-button-right {
    right: 10px;
}

.carousel-image-only {
    max-width: 100%;
    max-height: 400px;
    border-radius: 12px;
    object-fit: cover;
    margin: 0 auto;
    display: block;
}

/* RESPONSIVE: Ajustes para móviles y tablets */
@media (max-width: 768px) {
    .carousel-container {
        padding: 3rem 2rem 2rem 2rem; /* Más espacio arriba para flechas */
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    /* Contenedor para flechas en móvil que distribuye espacio */
    .carousel-nav-buttons-mobile {
        width: 100%;
        display: flex;
        justify-content: space-between; /* Separar flechas a los extremos */
        margin-bottom: 1rem;
    }

    /* Flechas vuelven a posición relativa y se adaptan */
    .carousel-nav-button-left,
    .carousel-nav-button-right {
        position: relative;
        top: auto;
        transform: none;
        margin: 0;
        display: inline-block;
        width: auto;
        padding: 12px;
        font-size: 20px;
    }

    .carousel-wrapper {
        order: 2;
        width: 100%;
        overflow: hidden;
    }

    .carousel-nav-button-left {
        order: 1;
    }

    .carousel-nav-button-right {
        order: 3;
    }
}


     .shine-title {
            text-align: center;
            font-weight: 600;
            font-style: italic;
            font-family: 'Raleway', 'Segoe UI', sans-serif;
            font-size: 1.75rem;
            line-height: 1.5;
            padding: 0 1rem;
            background: linear-gradient(
              to right,
              rgba(65, 25, 209, 0.6) 0%,
              #ffffff 10%,
              #0b3a91ff 20%,
              rgba(58, 33, 146, 0.6) 30%
            );
            background-size: 400% auto;
            background-position: 0 50%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            animation: shine 4s linear infinite;
            margin-bottom: 2rem;
            white-space: normal;
            word-break: break-word;
          }

          @keyframes shine {
            0% { background-position: -200% 50%; }
            100% { background-position: 200% 50%; }
          }

          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }

          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
          }

          @keyframes bounceSide {
            0%, 100% { transform: translateX(0); }
            50% { transform: translateX(-8px); }
          }
`;